export const lime50 = "#f6fbe8";
export const lime100 = "#f3fad6";
export const lime200 = "#e7f5ad";
export const lime300 = "#dbf085";
export const lime400 = "#cfeb5c";
export const lime500 = "#c3e634";
export const lime600 = "#a9da29";
export const lime700 = "#8fcf1e";
export const lime800 = "#75c314";
export const lime900 = "#5bb809";
export const lime1000 = "#45a501";
export const limeA100 = "#f3fa5d";
export const limeA200 = "#e1f24e";
export const limeA400 = "#a5d91a";
export const limeA500 = "#76c604";
export const limeA1000 = "#445012";
